export enum REFERENTIAl_STATES_ENDPOINT {
  ASSET = "states.assets",
  INTERVENTION = "states.interventions",
  INTERVENTIONTEMPLATE = "states.interventionTemplates",
  JOB_MODULE = "states.jobModules",
  OBSERVATION = "states.observations",
  PROJECT = "states.projects",
  USER = "states.users",
}
